  <template>
    <div class="filtering-container">
        <div class="filter-header">
          <transition name="fade">
            <div class="destination-index-tags" v-if="showIndexTags">
              <div class="tags-container">
                <template v-for="(filter, id) in filters" >
                  <template v-if="filter.length > 0">
                    <template v-for="(filterItem, key) in filter">
                      <a v-if="filterItem.checked"
                        href="#"
                        class="tag hovered"
                        :key="`${id}-${key}`"
                        @click.prevent="$emit('filter-checked-checkbox', {name: id, value: filterItem.id, event: {target: { checked: false}}})">
                        <span v-if="id === 'categories'" :class="`rating-stars r${filterItem.label[$locale]}`"></span>
                        <template v-if="id !== 'categories'">{{filterItem.label[$locale]}}</template>
                      </a>
                    </template>
                  </template>
                </template>
              </div>
              <a class="clear-all" @click="$emit('resetFilters')">
                <span>{{$t('commons.clear_filters')}}</span>
              </a>
            </div>
          </transition>
          <transition name="fade">
            <div class="total-hotels-counter" v-if="hotels.length > 0">
              {{hotels.length}} {{$t('commons.hotels_found_base')}}
            </div>
          </transition>
        </div>
      
      <transition-group name="fade">
        <div :key="0" class="hotel-list hotel-list-with-filtering" data-block-list="true" >
          <transition-group name="fade">
            <template v-if="hotels.length > 0">
              <HotelCard v-for="(hotel, key) in hotels" :hotel="hotel" :key="key" />
            </template>
          </transition-group>
          <transition name="fade">
            <template v-if="hotels.length === 0">
              <div class="message-hotels-not-found">
                <p  class="message-title"> {{$t("commons.title_message_hotels_not_found")}}</p>
                <p class="message-desc"> {{$t('commons.desc_message_hotels_not_found')}}</p>
              </div>
            </template>
          </transition>
        </div>
        <div :key="1" id="hotels-filter-map" data-mobile-text="t('commons.view_map_long')"></div>
      </transition-group>
    </div>
  </template>
  <style>
  </style>
  <script>
  import HotelCard from './HotelCard.vue';

  export default {
    name: 'HotelList',
    components: {
      HotelCard
    },
    props: {
      hotels: Array,
      filters: Object,
    },
    computed: {
      showIndexTags: function() {
        return this.filters.zones.filter(f => f.checked).length > 0
               || this.filters.countries.filter(f => f.checked).length > 0
               || this.filters.categories.filter(f => f.checked).length > 0
               || this.filters.features.filter(f => f.checked).length > 0
               || this.filters.specialties.filter(f => f.checked).length > 0
               || this.filters.nst.filter(f => f.checked).length > 0
      }
    }
  }

  </script>
